<!-- 注册sp3 -->
<template>
    <div class="sp3">
        <div class="sp3-main">
            <div class="sp3-title">———————————— 注册企业账户 ————————————</div>
            <div style="color: red"><i class="el-icon-circle-check"></i>您已经成功地提交了信息，感谢您的支持，车回佳将在三至五个工作日内会有专人联系您。</div>
            <div class="after-review">
                <div>审核通过后</div>
                <div></div>
            </div>

            <div class="fuli">
                <div class="fuli-title">您将获得更多服务、更多折扣、更多收入</div>
                <div class="fuli-main">
                    <div class="fuli-item">
                        <div class="fuli-icon">
                            <img src="../../assets/images/hg.png" alt="">
                            <div>更多服务</div>
                        </div>
                        <div class="fuli-dir">
                            认证企业将获得更多VIP服务，精准客户推送，大量资源聚集
                        </div>
                    </div>
                    <div class="fuli-item">
                        <div class="fuli-icon">
                            <img src="../../assets/images/zk.png" alt="">
                            <div>更多折扣</div>
                        </div>
                        <div class="fuli-dir">
                            认证企业享受优惠幅度更大，价格更具有吸引力
                        </div>
                    </div>
                    <div class="fuli-item">
                        <div class="fuli-icon">
                            <img src="../../assets/images/sr.png" alt="">
                            <div>更多收入</div>
                        </div>
                        <div class="fuli-dir">
                            认证企业更多的收入模式，一键推荐，永久收入
                        </div>
                    </div>
                </div>
            </div>


            <div class="contentUs">
                如果您有任何问题，请与我们客服联系！&nbsp;&nbsp;&nbsp;&nbsp;
                <i class="el-icon-phone-outline"></i>020-34397305&nbsp;&nbsp;&nbsp;&nbsp;
                <i class="el-icon-message"></i>market@chehuijia.com.cn
            </div>
        </div>
    </div>
</template>
<script>
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {

        },
        data(){
            return {

            }
        },
        mounted(){

        },
        methods:{

        }
    }
</script>
<style lang="less" scoped>
    .fuli {
        margin-bottom: 30px;
    }
    .fuli-main {
        display: flex;
        justify-content: space-between;
    }
    .fuli-item {
        text-align: center;
        width: 200px;
    }
    .fuli-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: white;
        margin: 30px auto 30px auto;
    }
    .fuli-title {
        font-size: 20px;
        font-weight: bold;
    }
    .fuli {
        background: #e6f5fd;
        border: 2px solid @theme;
        padding:  20px 35px;
        border-radius: 15px;
    }
    .sp3-title {
        text-align: center;
        font-size: @font-lg;
        margin-bottom: 35px;
    }
    .sp3-main {
        padding-top: 100px;
        max-width: 700px;
        margin: 0 auto;
    }
    .after-review {
        display: flex;
        height: 30px;
        margin: 30px 0;
        >div:nth-child(1){
            width: 150px;
            line-height: 30px;
            color: white;
            background: @theme;
            text-align: center;
        }
        >div:nth-child(2){
            width: 0;
            height: 0;
            border-top: 15px solid transparent;
            border-left: 20px solid @theme;
            border-bottom: 15px solid transparent;
        }
    }
    .fuli-icon {
        color: @theme;
        img {
            width: 80px;
            height: 80px;
            margin-bottom: 10px;
        }
    }
    .fuli-dir {
        text-indent: 2em;
        width: 150px;
        margin: 0 auto;
    }
    .contentUs {
        margin-bottom: 50px;
    }
</style>
